import React, { useContext, useState, useEffect } from 'react';
import { FormWrapper, 
         ButtonStyled,
         ButtonTextStyled } from './styles';
import { ContentContext } from '../../context/ContentContext';
import { validateEmail } from '../helpers/functions';
import { IoClose } from "react-icons/io5";
import { CircularProgress } from '@mui/material';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoEye, IoEyeOff } from "react-icons/io5";

const FormRegistro = (props) => {
    
    const { dataSaved, 
            setDataSaved,
            setScope,
            setShowLogin,
            setShowRegistro,
            setShowForgot,
            setOpenSnackbar,
            setSnackbarMessage,
            setSnackbarVariant } = props;

    const { provinces,
            register,
            getProvinces } = useContext(ContentContext);
            
    const [ formData, setFormData ] = useState({ name: { value:"", error: false, mandatory: true },
                                                 last_name: { value:"", error: false, mandatory: true },
                                                 email: { value:"", error: false, mandatory: true },
                                                 gender: { value:"", error: false, mandatory: true },
                                                 born_day: { value:"", error: false, mandatory: true },
                                                 born_month: { value:"", error: false, mandatory: true },
                                                 born_year: { value:"", error: false, mandatory: true },
                                                 city: { value:"", error: false, mandatory: true },
                                                 password: { value:"", error: false, mandatory: true },
                                                 repeat_password: { value:"", error: false, mandatory: true }, });

    const [ isLoading, setIsLoading ] = useState(false);
    const [ showRepeatPassword, setShowRepeatPassword ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);
    const [ registered, setRegistered ] = useState(false);

    const currentYear = new Date().getFullYear();

    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const years = Array.from({ length: currentYear - 1930 + 1 }, (_, i) => currentYear - i);
                                                
    const handleOnChanceForm = (e, name) => {
        
        let formData_update = {...formData};

        formData_update[name].value = e.target.value;

        switch (name) {
            case "name":
                //formData_update[name].value = e.target.value;
                break;
        
            default:
                break;
        }

        setFormData(formData_update);

    }

    const handleSaveData = () => {

        setIsLoading(true);
        let haveError = false;

        let formDataValidate = {...formData};
        Object.keys(formDataValidate).map((field) => {
            
            if(formDataValidate[field].mandatory){
                if(!formDataValidate[field].value.length){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
            }

            if(field === "email"){
                if(!validateEmail(formDataValidate[field].value)){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
                console.log(validateEmail(formDataValidate[field].value));
            }

            if(formDataValidate["password"].value !== formDataValidate["repeat_password"].value){
                haveError = true;
                formDataValidate["password"].error =  true;
                formDataValidate["repeat_password"].error =  true;
            }
            
            
        })
        setFormData(formDataValidate);
        /*
        if(!haveError){
            setIsLoading(false);
            setDataSaved(true);
        }else{
            setIsLoading(false);
        }
        */
        if(!haveError){
            const payload = {name: formData.name.value, 
                             last_name: formData.last_name.value,
                             email: formData.email.value,
                             gender: formData.gender.value,
                             born_day: formData.born_day.value,
                             born_month: formData.born_month.value,
                             born_year: formData.born_year.value,
                             city: formData.city.value,
                             password: formData.password.value};
            
            console.log("payload", payload);

            const response = register(payload);
            response.then(res => {
                setIsLoading(false);
                if(res.data.success){

                    setOpenSnackbar(true);
                    setSnackbarMessage("Te registraste correctamente");
                    setSnackbarVariant("success");

                    setRegistered(true);
                    //setShowLogin(true);    
                    //setShowRegistro(false);

                    resetForm();
                    /*
                    setScope(null);
                    trigger();
                    */

                }else{

                    let error_message = res.data.error_message;
                    setOpenSnackbar(true);
                    setSnackbarMessage(error_message);
                    setSnackbarVariant("error");

                }
                console.log("🚀 sendLogin", res)
            })
        }else{
            setIsLoading(false);
        }

        console.log("formData", formData);

    }

    const handleClose = () => {
        setScope(null);
    }

    const handleGotoLogin = () => {
        setShowLogin(true);
        setShowRegistro(false);
    }

    const handleShowRepeatPassword = () => {
        setShowRepeatPassword(!showRepeatPassword);
    }
    
    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const resetForm = () => {

        let formReset = {...formData};
        Object.keys(formReset).map((field) => {
            formReset[field].value = "";
            formReset[field].error = false;
        })
        setFormData(formReset);

    }

    useEffect(() => {
    
        getProvinces();
    
      return () => {}
    }, [])
    
    
    useEffect(() => {
      console.log("provinces", provinces)
    
      return () => {}
    }, [provinces])
    

    return (
        <FormWrapper>
            <div className='inner'>
                <div className='bt_close' onClick={handleClose}>
                    <p><IoClose /></p>
                </div>
                <div className='fields'>
                    {!registered ?
                    <>
                    <div className='field'>
                        <label>Nombre {formData.name.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.name.error ? " error" : ""}`}
                            type="text" 
                            value={formData.name.value} 
                            onChange={(e) => handleOnChanceForm(e, "name")}
                        />
                    </div>
                    <div className='field'>
                        <label>Apellido {formData.name.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.last_name.error ? " error" : ""}`}
                            type="text" 
                            value={formData.last_name.value} 
                            onChange={(e) => handleOnChanceForm(e, "last_name")}
                        />
                    </div>
                    <div className='field'>
                        <label>E-Mail {formData.name.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.email.error ? " error" : ""}`}
                            type="text" 
                            value={formData.email.value} 
                            onChange={(e) => handleOnChanceForm(e, "email")}
                        />
                    </div>
                    <div className='field'>
                        <label>Sexo {formData.name.mandatory ? "*" : ""}</label>
                        <select
                            className={`${formData.gender.error ? " error" : ""}`}
                            value={formData.gender.value} 
                            onChange={(e) => handleOnChanceForm(e, "gender")}
                        >
                            <option value={""}>Selecciná una opción</option>
                            <option value={"masculino"}>Masculino</option>
                            <option value={"femenino"}>Femenino</option>
                            <option value={"x"}>X</option>
                        </select>
                    </div>
                    <div className='field'>
                        <label>Fecha de Nacimiento {formData.name.mandatory ? "*" : ""}</label>
                        <div className='born_date'>
                            <div className='born_day'>
                                <label>Día</label>
                                <select
                                    className={`${formData.born_day.error ? " error" : ""}`}
                                    value={formData.born_day.value} 
                                    onChange={(e) => handleOnChanceForm(e, "born_day")}
                                >
                                    <option value={""}>Día</option>
                                    {days.map((day) => (
                                        <option key={day} value={day}>{day}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='born_month'>
                                <label>Mes</label>
                                <select
                                    className={`${formData.born_month.error ? " error" : ""}`}
                                    value={formData.born_month.value} 
                                    onChange={(e) => handleOnChanceForm(e, "born_month")}
                                >
                                    <option value={""}>Mes</option>
                                    {months.map((month) => (
                                        <option key={month} value={month}>{month}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='born_year'>
                                <label>Año</label>
                                <select
                                    className={`${formData.born_year.error ? " error" : ""}`}
                                    value={formData.born_year.value} 
                                    onChange={(e) => handleOnChanceForm(e, "born_year")}
                                >
                                    <option value={""}>Año</option>
                                    {years.map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    <div className='field'>
                        <label>Barrio {formData.city.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.city.error ? " error" : ""}`}
                            type="text" 
                            value={formData.city.value} 
                            onChange={(e) => handleOnChanceForm(e, "city")}
                        />
                    </div>
                    <div className='field'>
                        <label>Contraseña {formData.password.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.password.error ? " error" : ""}`}
                            type={`${showPassword ? "text" : "password" }`}
                            value={formData.password.value} 
                            onChange={(e) => handleOnChanceForm(e, "password")}
                        />
                        {!showPassword ? 
                        <div className='bt_show_password' onClick={handleShowPassword}>
                            <IoEye />
                        </div>
                        :
                        <div className='bt_show_password' onClick={handleShowPassword}>
                            <IoEyeOff />
                        </div>
                        }
                    </div>

                    <div className='field'>
                        <label>Repetir Contraseña {formData.repeat_password.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.repeat_password.error ? " error" : ""}`}
                            type={`${showRepeatPassword ? "text" : "password" }`}
                            value={formData.repeat_password.value} 
                            onChange={(e) => handleOnChanceForm(e, "repeat_password")}
                        />
                        {!showRepeatPassword ?
                        <div className='bt_show_password' onClick={handleShowRepeatPassword}>
                            <IoEye />
                        </div>
                        :
                        <div className='bt_show_password' onClick={handleShowRepeatPassword}>
                            <IoEyeOff />
                        </div>
                        }
                    </div>

                    <div className='aclaration_asterix'>Los campos con * son obligatorios</div>

                    <div className='actions'>
                        {!isLoading ? 
                            <ButtonStyled onClick={() => handleSaveData()}>
                                Enviar
                            </ButtonStyled>
                        :
                            <div className='loader'>
                                <CircularProgress />
                            </div>
                        }
                    </div>
                    </>
                    : 
                    <>
                        <p className='gracias'>Gracias por registrarte.</p>
                        <p className='menu_mi_avance'>En el Menú, Sección <span className="destaca">MI AVANCE</span>, podrás ver las Experiencias disponibles en el <span className="destaca">MERCADO RURAL.</span></p>
                    </>
                    }
                    
                </div>
                

                {/* 
                <div className='field'>
                    <label>Dirección {formData.address.mandatory ? "*" : ""}</label>
                    <input 
                        className={`${formData.address.error ? " error" : ""}`}
                        type="text" 
                        value={formData.address.value} 
                        onChange={(e) => handleOnChanceForm(e, "address")}
                    />
                </div>
                <div className='field'>
                    <label>Provincia {formData.province.mandatory ? "*" : ""}</label>
                    <select 
                        className={`${formData.province.error ? " error" : ""}`}
                        onChange={(e) => handleOnChanceForm(e, "province")}
                    >
                        <option value={""}>Selecciná una opción</option>
                        {provinces && provinces.map((province) => (
                            <option key={province.id} value={province.id}>{province.description}</option>
                        ))}
                        
                    </select>
                </div>
                <div className='field'>
                    <label>Ciudad {formData.city.mandatory ? "*" : ""}</label>
                    <input 
                        className={`${formData.city.error ? " error" : ""}`}
                        type="text" 
                        value={formData.city.value} 
                        onChange={(e) => handleOnChanceForm(e, "city")}
                    />
                </div>
                <div className='field'>
                    <label>Edad {formData.city.mandatory ? "*" : ""}</label>
                    <input 
                        className={`${formData.city.error ? " error" : ""}`}
                        type="text" 
                        value={formData.city.value} 
                        onChange={(e) => handleOnChanceForm(e, "city")}
                    />
                </div> */}

                
                
                <div className='actions'>
                    {!registered ? 
                    <ButtonTextStyled onClick={() => handleGotoLogin()}>
                        INGRESÁ
                    </ButtonTextStyled>
                    :
                    <ButtonStyled onClick={() => handleGotoLogin()}>
                        INGRESÁ
                    </ButtonStyled>
                    }
                </div>
            </div>
        </FormWrapper>
    );
};

export default FormRegistro;